import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TTCategoryType } from '../../../../../../createCategoryState/createCategoryContext';
import { UserRoles } from 'types';
import { categoryTypes, typesOfCategoriesDeniedForClientManagers } from 'appConstants';
import { Rule } from 'antd/lib/form';
import { ISelectOption } from 'components/Select/types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import FormSelect from 'components/Select/FormSelect';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './CategoryTypeSelect.module.scss';

interface ICategoryTypeSelect {
	setCategoryType: (value: TTCategoryType) => void;
}

const CategoryTypeSelect: React.FC<ICategoryTypeSelect> = ({ setCategoryType }) => {
	const isClientManager = useRoleAccess([UserRoles.CLIENT_MANAGER, UserRoles.GROUP_MANAGER]);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategoryType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		if (isClientManager) {
			const filteredCategoryTypes = categoryTypes.filter(
				(el) => !typesOfCategoriesDeniedForClientManagers.includes(el.categoryID),
			);
			return filteredCategoryTypes.map((el) => ({
				id: el.categoryID,
				name: tForm(el.categoryName),
				icon: (
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#${el.categoryName}`} />
					</svg>
				),
			}));
		}

		return categoryTypes.map((el) => ({
			id: el.categoryID,
			name: tForm(el.categoryName),
			icon: (
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#${el.categoryName}`} />
				</svg>
			),
		}));
	}, [tForm]);

	return (
		<FormSelect
			testId="CategoryTypeSelect"
			name="categoryType"
			label="categoryTypeLabel"
			options={mappedOptions}
			onChange={setCategoryType}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CategoryTypeSelect);
